import { AddCircle, Delete, Edit, Save } from "@material-ui/icons";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { Accordion, Button, Col, Modal, Row } from "react-bootstrap";
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import useCustomer from "../../../../context/CustomerContext";
import { useAddUnitTypeMutation, useDeleteUnitTypeMutation, useGetAllUnitTypeQuery, useLazyGetDetailByIdQuery, useUpdateUnitTypeMutation } from "../../../../features/productType/productListSlice";
import { useGetListOfUnitQuery } from "../../../../features/unit/unitSlice";
import Dialog from "../../../designSystem/Dialog";
import TextField from "../../../designSystem/TextField";
import errorHandler from "../../../hooks/ErrorHanlder";
import { useCustomData } from "../../../Sidebar/Permission";
import AccessorialSurcharge from "./Accessorial/AccessorialSurcharge";
import EditAccessorialSurcharge from "./Accessorial/EditAccessorial";
import ContractData from "./Contract/ContractData";
import EditContractdata from "./Contract/EditContractData";
import SaveContractdata from "./Contract/SaveContractData";
import CwtRatecard from "./CwtRateCard/CwtRatecard";
import EditCwtRatecard from "./CwtRateCard/EditCwtRatecard";
import CityDistance from "./FuelSurcharge/CityDistance";
import DistanceFuel from "./FuelSurcharge/DistanceFuel";
import EditCityDistance from "./FuelSurcharge/EditCitydistance";
import EditDistanceFuel from "./FuelSurcharge/EditDistanceFuel";
import EditRemoteLogin from "./FuelSurcharge/EditRemoteLogin";
import FuelCostTable from "./FuelSurcharge/FuelCostTable";
import RemoteLogin from "./FuelSurcharge/RemoteLogin";
import EditServiceSurcharge from "./Service/EditServiceSurcharge";
import ServiceSurcharge from "./Service/ServiceSurcharge";
import EditVehicleSurcharge from "./Vehicle/EditVehicleSurcharge";
import VehicleSurcharge from "./Vehicle/VehicleSurcharge";

const Contract = (props) => {
  const { register, handleSubmit, formState: { errors }, reset, setValue } = useForm({
    defaultValues: {
      unitType: "",
      abbrUnit: ""
    }
  });
  const { data, refetch: dataofUnit } = useGetListOfUnitQuery();
  const [permission] = useCustomData()
  const [addUnitType] = useAddUnitTypeMutation()
  const [getDataById, rowData] = useLazyGetDetailByIdQuery()
  const { data: getUnitType, refetch } = useGetAllUnitTypeQuery()
  const [updateUnit] = useUpdateUnitTypeMutation()
  const [deleteUnit] = useDeleteUnitTypeMutation()
  const { contractInfo } = useCustomer();
  const [showEditRate, setShowEditRate] = useState(true);
  const [isShow, setIsShow] = useState(false);
  const [isId, setIsId] = useState();
  const [open, setOpen] = useState(false);
  const [deletedItem, setDeleteItem] = useState();
  const isEditMode = props.selectedCard != "0"
  const selectedCard = props.selectedCard
  const [isEdit, setIsEdit] = useState(false);

  const editData = rowData?.data?.data

  useEffect(() => {
    if (rowData) {
      setValue('unitType', editData?.unitType)
      setValue('abbrUnit', editData?.abbrUnit)
    }
  }, [rowData])

  const showedithandler = () => {
    setShowEditRate(!showEditRate);
  }

  const onSubmit = async (data) => {
    try {
      if (isEdit) {
        await updateUnit({ unitId: isId, ...data }).unwrap()
      } else {
        await addUnitType(data).unwrap();
      }
      toast.success(isEdit ? "Updated Successfully" : "Added Successfully", {
        position: "top-center",
      });
      reset();
      refetch();
      dataofUnit();
      setIsEdit(false);
    } catch (error) {
      errorHandler(error);
    }
  };

  const deleteHandler = async () => {
    try {
      await deleteUnit(deletedItem).unwrap();
      toast.success("Deleted Successfully", {
        position: "top-center",
      });
      refetch()
      setOpen(false);
    } catch (error) {
      errorHandler(error);
    }
  }
  const onClose = () => {
    setIsShow(false)
    setOpen(false);
    setIsEdit(false);
    reset()
  }
  const onCancel = () => {
    setOpen(false);
    setIsEdit(false);
    reset()
  }

  const columns = [
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      width: 200,
      disableClickEventBubbling: true,
      renderCell: (data) => {
        const onClickEdit = async (e) => {
          e.stopPropagation();

          await getDataById(data?.row?.id)
          setIsId(data?.row?.id)
          setIsEdit(true)
        };
        const onClickDelete = (data) => {
          setOpen(true);
          setDeleteItem(data?.id)
        };

        return (
          <>
            <Dialog title="Delete Confirmation" show={open} onClose={() => setOpen(false)} description="Are you sure you want to delete this row?" onSubmit={deleteHandler} />
            <div className="action_btn">
              {permission.find(event => event.moduleId === 33)?.permissionType?.indexOf('Update') !== -1 ?
                <span className="edit_btn" onClick={onClickEdit}><Edit /></span>
                : <span className="edit_btn disable"><Edit /></span>}
              {permission.find(event => event.moduleId === 33)?.permissionType?.indexOf('Delete') !== -1 ?
                <span className="del_btn" onClick={() => onClickDelete(data)}><Delete /></span>
                : <span className="del_btn disable" ><Delete /></span>}
            </div>
          </>
        )
      },
    },
    { field: "unitType", headerName: "Product Name", width: 200 },
    { field: "abbrUnit", headerName: "Abbr", width: 200 },
  ];

  const rows = getUnitType?.data.map((data) => {
    return {
      id: data?.unitId,
      unitType: data?.unitType,
      abbrUnit: data?.abbrUnit,
    }
  })

  return (
    <>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>Rate Card</Accordion.Header>
          <Accordion.Body>
            <>
              <Row className="mb-4 justify-content-between">
                <Button onClick={() => setIsShow(true)} variant="primary" style={{ width: "20%" }}>
                  Create Product
                </Button>
                <Modal
                  size="lg"
                  show={isShow}
                  onHide={onClose}
                  aria-labelledby="example-modal-sizes-title-md"
                >
                  <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-md">
                      {" "}
                      Add Product Type
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col sm={3}>
                        <TextField label="Product Name" {...register('unitType', { required: 'Field is required' })} error={errors?.unitType?.message} />
                      </Col>
                      <Col sm={3}>
                        <TextField label="Abbreviation" {...register('abbrUnit', { required: 'Field is required' })} error={errors?.abbrUnit?.message} />
                      </Col>
                      <Col sm={{ span: 3, offset: 3 }}>
                        {!isEdit ?
                          <div className="section_action_btn">
                            <div className="add_btn"><button type="button" className="btn" onClick={handleSubmit(onSubmit)} ><AddCircle /> Add</button></div>
                          </div>
                          :
                          <div className="section_action_btn">
                            <div className="save_btn"><button type="button" className="btn" onClick={handleSubmit(onSubmit)} ><Save /> Save</button></div>
                            <div><button type="button" className="btn btn-outline-primary h-100 ms-1" onClick={onCancel} > Cancel</button></div>
                          </div>
                        }
                      </Col>
                    </Row>
                    <div className="user-role-table" style={{ height: "500px" }}>
                      <h6>List of Product Name</h6>
                      <DataGrid rows={rows} columns={columns} pageSize={15} rowsPerPageOptions={[1]} components={{ Toolbar: GridToolbar }} />
                    </div>
                  </Modal.Body>
                </Modal>
              </Row>
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Contract Info Section</Accordion.Header>
                  <Accordion.Body>
                    {showEditRate ?
                      <>{isEditMode ?
                        <> {permission?.find(event => event.moduleId === 40) ? <EditContractdata showedithandler={showedithandler} showEditRate={showEditRate} /> : <p className="no-access-msg">No Access Permission</p>}</> :
                        <> {permission?.find(event => event.moduleId === 40) ? <ContractData /> : <p className="no-access-msg">No Access Permission</p>}</>
                      }</>
                      : <SaveContractdata showedithandler={showedithandler} />}
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>Vehicle Surcharge Section</Accordion.Header>
                  <Accordion.Body>
                    {/* Vehicle surcharge section*/}
                    {isEditMode ?
                      <> {permission?.find(event => event.moduleId === 41) ? <EditVehicleSurcharge selectedCard={selectedCard} /> : <p className="no-access-msg">No Access Permission</p>}</> :
                      <> {permission?.find(event => event.moduleId === 41) ? <VehicleSurcharge /> : <p className="no-access-msg">No Access Permission</p>}</>
                    }
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>Service Surcharge Section</Accordion.Header>
                  <Accordion.Body>
                    {/* Service surcharge section*/}
                    {isEditMode ?
                      <> {permission?.find(event => event.moduleId === 42) ? <EditServiceSurcharge selectedCard={selectedCard} /> : <p className="no-access-msg">No Access Permission</p>}</> :
                      <> {permission?.find(event => event.moduleId === 42) ? <ServiceSurcharge /> : <p className="no-access-msg">No Access Permission</p>}</>
                    }
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>Accessorial Charge Section</Accordion.Header>
                  <Accordion.Body>
                    {/* Accessorial Charge section*/}
                    {isEditMode ?
                      <> {permission?.find(event => event.moduleId === 43) ? <EditAccessorialSurcharge selectedCard={selectedCard} /> : <p className="no-access-msg">No Access Permission</p>}</> :
                      <> {permission?.find(event => event.moduleId === 43) ? <AccessorialSurcharge /> : <p className="no-access-msg">No Access Permission</p>}</>}
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>CWT Rate Card Section</Accordion.Header>
                  <Accordion.Body>
                    {/* CWT Rate Card Section*/}
                    {isEditMode ?
                      <> {permission?.find(event => event.moduleId === 44) ? <EditCwtRatecard selectedCard={selectedCard} /> : <p className="no-access-msg">No Access Permission</p>}</> :
                      <> {permission?.find(event => event.moduleId === 44) ? <CwtRatecard /> : <p className="no-access-msg">No Access Permission</p>}</>
                    }
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header>Fuel Surcharge Section</Accordion.Header>
                  <Accordion.Body className="p-0">
                    {(contractInfo.FuelSurchargeMethod === "Select" || !contractInfo.FuelSurchargeMethod) &&
                      <><p>Please choose a Fuel Surcharge Method in the Contract Section!</p></>
                    }
                    {(contractInfo.FuelSurchargeMethod === 2 || contractInfo.FuelSurchargeMethod === '2') &&
                      <>
                        {isEditMode ?
                          <> {permission?.find(event => event.moduleId === 45) ? <EditCityDistance selectedCard={selectedCard} /> : <p className="no-access-msg">No Access Permission</p>}</> :
                          <> {permission?.find(event => event.moduleId === 45) ? <CityDistance /> : <p className="no-access-msg">No Access Permission</p>}</>
                        }

                        {isEditMode ?
                          <> {permission?.find(event => event.moduleId === 45) ? <EditDistanceFuel selectedCard={selectedCard} /> : <p className="no-access-msg">No Access Permission</p>}</> :
                          <> {permission?.find(event => event.moduleId === 45) ? <DistanceFuel /> : <p className="no-access-msg">No Access Permission</p>}</>
                        }

                        {isEditMode ?
                          <> {permission?.find(event => event.moduleId === 45) ? <FuelCostTable edit={true} /> : <p className="no-access-msg">No Access Permission</p>}</> :
                          <> {permission?.find(event => event.moduleId === 45) ? <FuelCostTable edit={false} /> : <p className="no-access-msg">No Access Permission</p>}</>
                        } </>
                    }

                    {(contractInfo.FuelSurchargeMethod === 1 || contractInfo.FuelSurchargeMethod === '1') && <>
                      {isEditMode ?
                        <> {permission?.find(event => event.moduleId === 45) ? <EditRemoteLogin selectedCard={selectedCard} /> : <p className="no-access-msg">No Access Permission</p>}</> :
                        <> {permission?.find(event => event.moduleId === 45) ? <RemoteLogin /> : <p className="no-access-msg">No Access Permission</p>}</>
                      }
                    </>}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  )
}
export default Contract;
